"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ethers_1 = require("ethers");
var bn_js_1 = require("bn.js");
var ethereum_checksum_address_1 = require("ethereum-checksum-address");
var BaseStreamClient_1 = require("../common/BaseStreamClient");
var types_1 = require("../common/types");
var constants_1 = require("./constants");
var abi_1 = __importDefault(require("./abi"));
var ercAbi_1 = __importDefault(require("./ercAbi"));
var constants_2 = require("../common/constants");
var types_2 = require("./types");
var EvmStreamClient = /** @class */ (function (_super) {
    __extends(EvmStreamClient, _super);
    function EvmStreamClient(clusterUrl, chain, signer, cluster, programId) {
        if (cluster === void 0) { cluster = types_1.ICluster.Mainnet; }
        var _this = _super.call(this) || this;
        if (chain !== types_1.IChain.Ethereum && chain !== types_1.IChain.BNB && chain !== types_1.IChain.Polygon) {
            throw new Error("Wrong chain. Supported chains are Ethereum , BNB and Polygon!");
        }
        if (programId) {
            _this.programId = programId;
        }
        else {
            switch (chain) {
                case types_1.IChain.Ethereum:
                    _this.programId = constants_1.ETHEREUM_PROGRAM_IDS[cluster];
                    break;
                case types_1.IChain.BNB:
                    _this.programId = constants_1.BNB_PROGRAM_IDS[cluster];
                    break;
                case types_1.IChain.Polygon:
                    _this.programId = constants_1.POLYGON_PROGRAM_IDS[cluster];
                    break;
            }
        }
        _this.provider = new ethers_1.ethers.providers.JsonRpcProvider(clusterUrl);
        _this.signer = signer;
        var baseContract = new ethers_1.ethers.Contract(_this.programId, abi_1.default);
        _this.readContract = baseContract.connect(_this.provider);
        _this.writeContract = baseContract.connect(_this.signer);
        return _this;
    }
    EvmStreamClient.prototype.create = function (streamData) {
        return __awaiter(this, void 0, void 0, function () {
            var multiParams, fees, args, sum, tokenContract, approvalTx, result, confirmedTx, metadataId;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        multiParams = __assign(__assign({}, streamData), { recipients: [streamData] });
                        return [4 /*yield*/, (_a = this.readContract).getWithdrawalFees.apply(_a, __spreadArray([], __read(this.getFeeParams(multiParams)), false))];
                    case 1:
                        fees = _c.sent();
                        return [4 /*yield*/, this.generateMultiPayloads(multiParams)];
                    case 2:
                        args = (_c.sent())[0];
                        sum = streamData.amount.mul(new bn_js_1.BN(constants_2.BASE_FEE)).div(new bn_js_1.BN(1000000));
                        tokenContract = new ethers_1.ethers.Contract(streamData.tokenId, ercAbi_1.default, this.signer);
                        return [4 /*yield*/, tokenContract.approve(this.programId, sum.toString())];
                    case 3:
                        approvalTx = _c.sent();
                        return [4 /*yield*/, approvalTx.wait()];
                    case 4:
                        _c.sent();
                        return [4 /*yield*/, (_b = this.writeContract).create.apply(_b, __spreadArray(__spreadArray([], __read(args), false), [{ value: fees.value }], false))];
                    case 5:
                        result = _c.sent();
                        return [4 /*yield*/, result.wait()];
                    case 6:
                        confirmedTx = _c.sent();
                        metadataId = this.formatMetadataId(confirmedTx.events.find(function (item) { return item.event === "ContractCreated"; }).args[0]);
                        return [2 /*return*/, {
                                ixs: [],
                                txId: result.hash,
                                metadataId: metadataId,
                            }];
                }
            });
        });
    };
    EvmStreamClient.prototype.createMultiple = function (multipleStreamData) {
        return __awaiter(this, void 0, void 0, function () {
            var fees, args, sum, tokenContract, approvalTx, creationPromises, signatures, results, confirmations, successes, metadatas, metadataToRecipient, failures;
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (_a = this.readContract).getWithdrawalFees.apply(_a, __spreadArray([], __read(this.getFeeParams(multipleStreamData)), false))];
                    case 1:
                        fees = _b.sent();
                        return [4 /*yield*/, this.generateMultiPayloads(multipleStreamData)];
                    case 2:
                        args = _b.sent();
                        sum = multipleStreamData.recipients
                            .reduce(function (acc, v) { return acc.add(v.amount); }, new bn_js_1.BN(0))
                            .mul(new bn_js_1.BN(constants_2.BASE_FEE))
                            .div(new bn_js_1.BN(1000000));
                        tokenContract = new ethers_1.ethers.Contract(multipleStreamData.tokenId, ercAbi_1.default, this.signer);
                        return [4 /*yield*/, tokenContract.approve(this.programId, sum.toString())];
                    case 3:
                        approvalTx = _b.sent();
                        return [4 /*yield*/, approvalTx.wait()];
                    case 4:
                        _b.sent();
                        creationPromises = args.map(function (item) {
                            var _a;
                            return (_a = _this.writeContract).create.apply(_a, __spreadArray(__spreadArray([], __read(item), false), [{ value: fees.value }], false));
                        });
                        signatures = [];
                        return [4 /*yield*/, Promise.all(creationPromises)];
                    case 5:
                        results = _b.sent();
                        return [4 /*yield*/, Promise.allSettled(results.map(function (result) { return result.wait(); }))];
                    case 6:
                        confirmations = _b.sent();
                        successes = confirmations
                            .filter(function (el) { return el.status === "fulfilled"; })
                            .map(function (el) { return el.value; });
                        signatures.push.apply(signatures, __spreadArray([], __read(successes.map(function (el) { return el.hash; })), false));
                        metadatas = confirmations.map(function (result) {
                            return result.status === "fulfilled"
                                ? _this.formatMetadataId(result.value.events.find(function (item) { return item.event === "ContractCreated"; })
                                    .args[0])
                                : null;
                        });
                        metadataToRecipient = metadatas.reduce(function (acc, value, index) {
                            if (value) {
                                acc[value] = multipleStreamData.recipients[index];
                            }
                            return acc;
                        }, {});
                        failures = confirmations
                            .filter(function (el) { return el.status === "rejected"; })
                            .map(function (el) { return el.reason; });
                        return [2 /*return*/, {
                                txs: signatures,
                                metadatas: metadatas.filter(Boolean),
                                metadataToRecipient: metadataToRecipient,
                                errors: failures,
                            }];
                }
            });
        });
    };
    EvmStreamClient.prototype.withdraw = function (withdrawData) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.writeContract.withdraw(withdrawData.id, withdrawData.amount.toString())];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, {
                                ixs: [],
                                txId: result.hash,
                            }];
                }
            });
        });
    };
    EvmStreamClient.prototype.cancel = function (cancelData) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.writeContract.cancel(cancelData.id)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, {
                                ixs: [],
                                txId: result.hash,
                            }];
                }
            });
        });
    };
    EvmStreamClient.prototype.transfer = function (transferData) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.writeContract.transfer(transferData.id, transferData.newRecipient)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, {
                                ixs: [],
                                txId: result.hash,
                            }];
                }
            });
        });
    };
    EvmStreamClient.prototype.topup = function (topupData) {
        return __awaiter(this, void 0, void 0, function () {
            var fees, sum, stream, tokenContract, approvalTx, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.readContract.getTopUpWithdrawalFees(topupData.id, topupData.amount.toString())];
                    case 1:
                        fees = _a.sent();
                        sum = topupData.amount.mul(new bn_js_1.BN(constants_2.BASE_FEE)).div(new bn_js_1.BN(1000000));
                        return [4 /*yield*/, this.getOne({ id: topupData.id })];
                    case 2:
                        stream = _a.sent();
                        tokenContract = new ethers_1.ethers.Contract(stream.mint, ercAbi_1.default, this.signer);
                        return [4 /*yield*/, tokenContract.approve(this.programId, sum.toString())];
                    case 3:
                        approvalTx = _a.sent();
                        return [4 /*yield*/, approvalTx.wait()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.writeContract.topUp(topupData.id, topupData.amount.toString(), {
                                value: fees.value,
                            })];
                    case 5:
                        result = _a.sent();
                        return [2 /*return*/, {
                                ixs: [],
                                txId: result.hash,
                            }];
                }
            });
        });
    };
    EvmStreamClient.prototype.update = function (updateData) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.writeContract.update(updateData.id, updateData.enableAutomaticWithdrawal ? [true] : [], updateData.withdrawFrequency ? [updateData.withdrawFrequency.toString()] : [], updateData.amountPerPeriod ? [updateData.amountPerPeriod.toString()] : [])];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, {
                                ixs: [],
                                txId: result.hash,
                            }];
                }
            });
        });
    };
    EvmStreamClient.prototype.getOne = function (_a) {
        var id = _a.id;
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.readContract.getById(id)];
                    case 1:
                        result = _b.sent();
                        return [2 /*return*/, new types_2.EvmContract(result)];
                }
            });
        });
    };
    EvmStreamClient.prototype.get = function (_a) {
        var address = _a.address, 
        // type = StreamType.All,
        _b = _a.direction, 
        // type = StreamType.All,
        direction = _b === void 0 ? types_1.StreamDirection.All : _b;
        return __awaiter(this, void 0, void 0, function () {
            var addresses, senderAddresses, recipientAddresses, uniqueAddresses, results;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        addresses = [];
                        if (!(direction === types_1.StreamDirection.All || direction === types_1.StreamDirection.Outgoing)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.readContract.getBySender(address)];
                    case 1:
                        senderAddresses = _c.sent();
                        addresses.push.apply(addresses, __spreadArray([], __read(senderAddresses), false));
                        _c.label = 2;
                    case 2:
                        if (!(direction === types_1.StreamDirection.All || direction === types_1.StreamDirection.Incoming)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.readContract.getByRecipient(address)];
                    case 3:
                        recipientAddresses = _c.sent();
                        addresses.push.apply(addresses, __spreadArray([], __read(recipientAddresses), false));
                        _c.label = 4;
                    case 4:
                        uniqueAddresses = __spreadArray([], __read(new Set(addresses)), false);
                        return [4 /*yield*/, this.readContract.getMultiple(uniqueAddresses)];
                    case 5:
                        results = _c.sent();
                        return [2 /*return*/, results.map(function (result, index) { return [uniqueAddresses[index], new types_2.EvmContract(result)]; })];
                }
            });
        });
    };
    /**
     * Returns StreamClient protocol program ID.
     */
    EvmStreamClient.prototype.getProgramId = function () {
        return this.programId;
    };
    // Utility function to prepare transaction payloads for multiple recipients.
    EvmStreamClient.prototype.generateMultiPayloads = function (multipleStreamData) {
        return __awaiter(this, void 0, void 0, function () {
            var sender;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.signer.getAddress()];
                    case 1:
                        sender = _a.sent();
                        return [2 /*return*/, multipleStreamData.recipients.map(function (recipient) {
                                return [
                                    multipleStreamData.tokenId,
                                    recipient.amount.toString(),
                                    multipleStreamData.period,
                                    recipient.amountPerPeriod.toString(),
                                    multipleStreamData.start,
                                    recipient.cliffAmount.toString(),
                                    [
                                        multipleStreamData.cancelableBySender,
                                        multipleStreamData.cancelableByRecipient,
                                        multipleStreamData.transferableBySender,
                                        multipleStreamData.transferableByRecipient,
                                        multipleStreamData.canTopup,
                                        multipleStreamData.canPause || false,
                                        multipleStreamData.canUpdateRate || false,
                                        multipleStreamData.automaticWithdrawal || false,
                                        multipleStreamData.withdrawalFrequency || 0,
                                        recipient.name,
                                    ],
                                    recipient.recipient,
                                    multipleStreamData.partner || sender,
                                ];
                            })];
                }
            });
        });
    };
    EvmStreamClient.prototype.getFeeParams = function (multipleStreamData) {
        return [
            multipleStreamData.recipients[0].amount.toString(),
            multipleStreamData.period,
            multipleStreamData.recipients[0].amountPerPeriod.toString(),
            multipleStreamData.start,
            multipleStreamData.recipients[0].cliffAmount.toString(),
            multipleStreamData.automaticWithdrawal || false,
            multipleStreamData.withdrawalFrequency || 0,
        ];
    };
    EvmStreamClient.prototype.formatMetadataId = function (id) {
        // 40 chars is ethereum address size
        return (0, ethereum_checksum_address_1.toChecksumAddress)("0x".concat(id.slice(-40)));
    };
    return EvmStreamClient;
}(BaseStreamClient_1.BaseStreamClient));
exports.default = EvmStreamClient;
